<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="明细类型">
            <el-select
                style="width:100%"
                v-model="queryParamForm.detailType"
                :loading="loading"
                clearable
              >
                <el-option
                  v-for="item in detailTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getListWalletDetail"
              >查询</el-button
            >
            <el-button type="primary" @click="addBasePrice" v-if="userInfo.data.roleId!=9">充值/余额扣减</el-button>
            <el-button @click="$router.go(-1)">取消</el-button>
          </el-col>
           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
           </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column label="明细记录">
             <template slot-scope="scope">
            <span>{{ scope.row.typeDesc }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="walletCode" label="钱包ID"> </el-table-column>
        <el-table-column prop="serviceName" label="回收商名称"> </el-table-column>
         <el-table-column label="金额">  
          <template slot-scope="scope">
            <span>{{ scope.row.symbol}}{{ scope.row.amount }}</span>
          </template></el-table-column>
            <el-table-column prop="balance" label="钱包余额"> </el-table-column>
        <el-table-column prop="orderNo" label="订单号"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="realName" label="操作人"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      title="充值/余额扣减"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editServiceProviderForm"
            :model="editServiceProviderForm"
            :rules="editorFormRules"
            label-width="120px"
          >
             <div style="margin-left:10px;margin-bottom:20px">
              你的操作将改变（{{serviceName}}）的钱包余额，请谨慎操作！！！
            </div>
            
            <el-form-item
              label="操作选择"
              prop="type"
            >
              <el-select
                style="width:100%"
                v-model="editServiceProviderForm.type"
                :loading="loading"
                clearable
              >
                <el-option
                  v-for="item in changeWalletTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="充值/扣减金额" prop="monney">
              <el-input clearable v-model="editServiceProviderForm.monney" 
               placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        detailType: null
      },
      detailTypeList:[{id:1,name:"回收红包"},{id:2,name:"回收退单"},{id:3,name:"充值"},{id:4,name:"提现"},{id:5,name:"手动充值"},{id:6,name:"手动扣减"},{id:7,name:"充值退款"},{id:8,name:"支付回收款"},{id:9,name:"退还回收款"}],

      changeWalletTypeList:[{id:5,name:"充值"},{id:6,name:"余额扣减"}],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        type: null,
        monney: null,
        walletId: null,
      },

      editorFormRules: {
        type: [
          { required: true, message: "请选择操作类型", trigger: "change" },
        ],
        monney: [
          { required: true, message: "请输入金额", trigger: "change" },
        ],
      },

      dlgType: "change",

      // 选择
      loading: false,

      queryServiceList: [],

      walletId: '',
      serviceName: '',
      userInfo:{}
    };
  },
  watch: {},
  computed: {},
  methods: {
      // click事件
    exportExcelData () {
      let self = this
      let walletId = this.$route.query.id;
      self.$api
        .listWalletDetail({
          page: 1,
          size: self.tableTotal,
          type: self.queryParamForm.detailType || null,
          walletId: walletId,
        })
        .then((res) => {
          var downLoadTableData = res.data.records || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName = ["操作类型", "钱包编码","回收商","更改金额","钱包余额","订单号","创建时间","操作人"];
                const filterVal = ["typeDesc", "walletCode", "serviceName", "amount","balance","orderNo", "createTime","realName"];
                const data = downLoadTableData.map(v => filterVal.map(j => {
                        if(j=="amount"){
                           return v.symbol + v[j];
                        }else{
                          return v[j]
                        }    
                }
                 ));
                export_json_to_excel(fieldName, data, "回收商钱包明细"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
      //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getListWalletDetail();
    },

    // 获取表格数据
    getListWalletDetail() {
      let self = this;
      let walletId = this.$route.query.id;
      self.$api
        .listWalletDetail({
          page: self.currentPage,
          size: self.pageSize,
          type: self.queryParamForm.detailType || null,
          walletId: walletId,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.serviceName =  this.$route.query.serviceName;
      this.editServiceProviderForm=this.$options.data().editServiceProviderForm;
      this.$nextTick(()=>{
          this.$refs['editServiceProviderForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      self.editServiceProviderForm = JSON.parse(JSON.stringify(row));
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editServiceProviderForm"].validate((valid) => {
        if (valid) {
          let params = this.editServiceProviderForm;
          params.walletId = this.$route.query.id;
          self.$api.processBalanceAdmin(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getListWalletDetail();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      row.modelId = null;
      this.$api.updateQuoteUser(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getListWalletDetail();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getListWalletDetail();
    self.getServiceList();
    self.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
};
</script>
<style lang="less" scoped>
</style>
